import { render } from "./MCombobox.vue?vue&type=template&id=64dd1e2b&scoped=true"
import script from "./MCombobox.vue?vue&type=script&lang=js"
export * from "./MCombobox.vue?vue&type=script&lang=js"

import "./MCombobox.vue?vue&type=style&index=0&id=64dd1e2b&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64dd1e2b"]])

export default __exports__